import { useState } from 'react';

const EnquiryModal = ({ show, onClose, formtitle }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    phone: '',
  });

  if (!show) return null;

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Phone must be 10 digits';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      const response = await fetch(
        'https://minespacerealty.onrender.com/send',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      console.log('API Response:', data);
      alert(data.message);

      setFormData({ name: '', email: '', phone: '' });
      setErrors({ name: '', email: '', phone: '' });
      onClose();
    } catch (error) {
      console.error('API Error:', error);
      alert('Something went wrong. Please try again later.');
    }
  };



  

  return (
    <div
      className="modal fade show"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1050,
      }}
      tabIndex="-1"
      aria-labelledby="enquiryModalLabel"
      aria-modal="true"
      role="dialog"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content" style={{ borderRadius: '15px' }}>
          <div className="modal-header border-0">
            <h5 className="modal-title" id="enquiryModalLabel">
              <i className="fas fa-envelope me-2 text-primary"></i>{formtitle}
            </h5>
            <button
              type="button"
              className="btn"
              onClick={onClose}
              aria-label="Close"
              style={{
                fontSize: '1.2rem',
                color: '#555',
                border: 'none',
                background: 'none',
              }}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="modal-body pt-0 px-4 pb-4">
            <form onSubmit={handleSubmit}>
              <div className="mb-3 input-group">
                <span className="input-group-text bg-light border-end-0 rounded-start">
                  <i className="fas fa-user"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-start-0 rounded-end"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </div>
              {errors.name && (
                <div className="text-danger mb-2">{errors.name}</div>
              )}

              <div className="mb-3 input-group">
                <span className="input-group-text bg-light border-end-0 rounded-start">
                  <i className="fas fa-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control border-start-0 rounded-end"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  required
                />
              </div>
              {errors.email && (
                <div className="text-danger mb-2">{errors.email}</div>
              )}

              <div className="mb-3 input-group">
                <span className="input-group-text bg-light border-end-0 rounded-start">
                  <i className="fas fa-phone-alt"></i>
                </span>
                <input
                  type="tel"
                  className="form-control border-start-0 rounded-end"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  required
                />
              </div>
              {errors.phone && (
                <div className="text-danger mb-2">{errors.phone}</div>
              )}

              <button
                type="submit"
                className="btn btn-primary w-100"
                style={{ borderRadius: '8px' }}
              >
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryModal;
